/* Totaal in winkelwagen-lade en cart-pagina gelijk houden aan Shopify's cart.total_price.
   Aanleiding (26-09-2026): de BSS B2B-app herschrijft de prijzen in de lade en telt daarbij de regels op
   zonder automatische kortingen (bv. gratis cadeauproduct) → totaal stond €108 te hoog, terwijl de checkout
   wel klopte. Dit script zet het bedrag terug zodra het afwijkt. */
(function () {
  const SELECTOR = 'cart-drawer .totals__total-value, .cart__footer .totals__total-value, #main-cart-footer .totals__total-value';
  let timer = null;
  let bezig = false;
  let eigenWijziging = 0;

  function formatteer(cents) {
    const bedrag = new Intl.NumberFormat('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100);
    return `€${bedrag} EUR`;
  }
  function naarCents(tekst) {
    const m = String(tekst).replace(/\s/g, '').match(/([\d.]+),(\d{2})/);
    if (!m) return null;
    return Number(m[1].replace(/\./g, '')) * 100 + Number(m[2]);
  }

  async function corrigeer() {
    const velden = document.querySelectorAll(SELECTOR);
    if (!velden.length || bezig) return;
    bezig = true;
    try {
      const cart = await fetch(`${window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart'}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      velden.forEach((el) => {
        const huidig = naarCents(el.textContent);
        if (huidig !== null && huidig !== cart.total_price) {
          eigenWijziging = Date.now();
          el.textContent = formatteer(cart.total_price);
        }
      });
    } catch (e) {
      /* stil: bij een netwerkfout laten we de weergave staan */
    } finally {
      bezig = false;
    }
  }

  function plan() {
    if (Date.now() - eigenWijziging < 150) return; // eigen tekstwijziging niet opnieuw oppakken
    clearTimeout(timer);
    timer = setTimeout(corrigeer, 600);
  }

  const doel = document.querySelector('cart-drawer') || document.querySelector('#main-cart-footer') || document.querySelector('.cart__footer');
  if (!doel) return;
  new MutationObserver(plan).observe(doel, { childList: true, subtree: true, characterData: true });
  if (document.readyState === 'complete') plan();
  else window.addEventListener('load', plan);
})();
